import axios from 'axios';

const api = () => `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getService = (serviceId) => axios.get(`${api()}/worship/services/${serviceId}`).then((response) => response.data);

// Volledige nieuwe volgorde + de volgorde die de client zag: de server weigert (409) als iemand anders intussen wijzigde.
export const reorderSetlist = (serviceId, itemIds, baseItemIds) => axios
  .put(`${api()}/worship/services/${serviceId}/setlist/order`, { item_ids: itemIds, base_item_ids: baseItemIds })
  .then((response) => response.data);

export const addSetlistItem = (serviceId, item) => axios
  .post(`${api()}/worship/services/${serviceId}/setlist/items`, item)
  .then((response) => response.data);

export const removeSetlistItem = (serviceId, itemId) => axios
  .delete(`${api()}/worship/services/${serviceId}/setlist/items/${encodeURIComponent(itemId)}`)
  .then((response) => response.data);

export const searchSongs = (query, { skip = 0, limit = 20, signal } = {}) => axios
  .get(`${api()}/worship/songs/search`, { params: { q: query || undefined, skip, limit }, signal })
  .then((response) => response.data);
